import axios from "axios";
import QRCode from "qrcode.react";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import JsBarcode from "jsbarcode";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// import "./VerificationReport.scss";

const VerificationReportById = () => {
  const [physicalData, setPhysicalData] = useState([]);
  const [radiologyData, setRadiologyData] = useState([]);
  const [pathologyData, setPathologyData] = useState([]);
  const [radiologyComment, setRadiologyComment] = useState();
  const [radiologyRiskFactor, setRadiologyRiskFactor] = useState();
  const [pathologyCommentRisk, setPathologyCommentRisk] = useState();
  const [physicalCommentRisk, setPhysicalCommentRisk] = useState();
  const [riskFactor, setRiskFactor] = useState("");
  const [physicalRiskFactor, setPhysicalRiskFactor] = useState("");
  const [state, setState] = useState([]);

  const { id } = useParams();
  const userId = id;
  const navigate = useNavigate();
  const pdfRef = useRef();

  const urlWithBase64ID = `https://${process.env.REACT_APP_API_BASE_URL}/medical-verification/result/report/print/${state?.user_id}`;
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const formattedMedicalDate = state?.createdAt
    ? new Date(state.createdAt).toLocaleDateString("en-GB")
    : "---";
  const formattedBirthDate = state?.user?.date_of_birth
    ? new Date(state?.user?.date_of_birth).toLocaleDateString("en-GB")
    : "---";

  const registrationNo = state?.user?.registration_no;

  const patientIdBarcode = document.createElement("canvas");
  JsBarcode(patientIdBarcode, String(registrationNo), {
    height: 20,
    margin: 0,
    displayValue: false,
  });

  const patientIdDataUrl = patientIdBarcode.toDataURL();

  const getUserDetail = async () => {
    try {
      const response = await axios.get(`${baseUrl}/user-details/${userId}`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
        },
      });
      setState(response.data.data.userDetail);
    } catch (error) {
      console.error(error);
    }
  };

  const getPhysicalData = () => {
    axios
      .get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/reports/get-healthcard-results/${userId}/${3}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setPhysicalData(response?.data);
      })
      .catch((err) => console.log(err));
  };

  const getComment = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/reports/get-physical-comments/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const { comments } = response?.data?.data;
      setPhysicalRiskFactor(comments);
    } catch (error) {
      console.error(error);
    }
  };

  const getRadiologyData = () => {
    axios
      .get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/reports/get-healthcard-results/${userId}/${1}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setRadiologyData(response?.data);
      })
      .catch((err) => console.log(err));
  };

  const getPathologyData = () => {
    axios
      .get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/reports/get-healthcard-results/${userId}/${2}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setPathologyData(response?.data);
      })
      .catch((err) => console.log(err));
  };

  const getPathologyComment = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/reports/get-pathology-comments/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const commentsData = response?.data?.data;
      setPathologyCommentRisk(commentsData?.comments);
    } catch (error) {
      console.error(error);
    }
  };

  const getPhysicalComment = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/reports/get-physical-comments/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response?.data?.data);
      const commentsData = response?.data?.data;
      console.log(commentsData?.comments);
      setPhysicalCommentRisk(commentsData?.comments);
    } catch (error) {
      console.error(error);
    }
  };

  async function getComments() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/reports/get-comments/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const comments = response?.data?.data || [];

      setRadiologyComment(comments?.comments);
    } catch (error) {
      console.log(error);
    }
  }

  async function getRiskFactor() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/reports/get-risk-factor/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const risk = response?.data?.data || [];

      setRadiologyRiskFactor(risk[0]?.comments);
      setRiskFactor(risk[0]?.comments);
    } catch (error) {
      console.log(error);
    }
  }

  const pdfGenerate = async () => {
    if (!pdfRef.current) return;

    const element = pdfRef.current;

    if (element) {
      try {
        const pdf = new jsPDF({
          format: "a4",
          unit: "mm",
          margin: 5,
        }); // Create a single PDF instance
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        let currentPageHeight = 0; // Track current page height

        const canvas = await html2canvas(element, { scale: 1 }); // Double the resolution
        const imgData = canvas.toDataURL("image/png");
        const contentWidth = canvas.width;
        const contentHeight = canvas.height;

        // Calculate scaling factor to fit content within margins
        const scaleX = Math.min(1, width / contentWidth);
        const scaleY = Math.min(1, (height + 5) / contentHeight); // Adjust for margins
        const scale = Math.min(scaleX, scaleY);

        // Center the content horizontally
        const xOffset = (width - contentWidth * scale) / 2;

        // Check if component height fits on current page
        if (currentPageHeight + contentHeight * scale <= height + 5) {
          pdf.addImage(
            imgData,
            "PNG",
            xOffset,
            currentPageHeight,
            contentWidth * scale,
            contentHeight * scale
          );
          currentPageHeight += contentHeight * scale;
        } else {
          // Add page break and adjust for next page
          pdf.addPage();
          currentPageHeight = 0;
          pdf.addImage(
            imgData,
            "PNG",
            xOffset,
            currentPageHeight,
            contentWidth * scale,
            contentHeight * scale
          );
          currentPageHeight += contentHeight * scale;
        }

        pdf.save(`${state?.user?.registration_no}.pdf`);
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    }
  };

  const collection = state?.user?.user_collections?.map(
    (collection) => collection.investigation_category?.investigation_group_id
  );
  const uniqueCollection = [...new Set(collection)];

  useEffect(() => {
    getPhysicalData();
    getRadiologyData();
    getPathologyData();
    getComments();
    getRiskFactor();
    getPathologyComment();
    getPhysicalComment();
    const handleBrowserBackButton = () => {
      navigate(`/medical-verification`);
    };

    window.addEventListener("onload", handleBrowserBackButton);

    window.addEventListener("popstate", handleBrowserBackButton);

    return () => {
      window.removeEventListener("popstate", handleBrowserBackButton);
    };
  }, []);

  useEffect(() => {
    userId && getComments();
    userId && getComment();
    userId && getRiskFactor();
    userId && getUserDetail();
  }, [userId]);

  // useEffect(() => {
  //   if (state?.user?.registration_no) {
  //     pdfGenerate();
  //   }
  // }, [userId]);

  const pregnancyField = state?.introducer_user?.pregnancyField;

  const rowSpanValue = pregnancyField === 1 && state?.gender?.id === 2 ? 3 : 2;

  return (
    <section
      className="verification-certificate"
      ref={pdfRef}
      style={{
        width: "1500px",
        fontFamily: "Verdana",
        fontWeight: "bolder",
      }}
    >
      <div className="">
        <div className="row">
          <div className="col-2 p-1 h-100">
            <div className="report-avatar border border-2 border-dark">
              {state?.user?.image ? (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}/users/${state?.user?.image}`}
                  className="img-fluid"
                  alt="patient"
                />
              ) : (
                <img
                  src="./dummy.jpg"
                  alt="patient"
                  className="img-fluid border border-2 border-dark"
                />
              )}
            </div>
            <div className="w-100">
              <img src={patientIdDataUrl} alt="" className="w-100 img-fluid" />
            </div>
          </div>
          <div
            className="col-8 p-1"
            style={{ fontFamily: "Verdana", fontWeight: "bolder" }}
          >
            <table className="w-100 h-100 table table-bordered border border-2 border-dark mb-0 fw-bold">
              <tbody>
                <tr>
                  <td className="text-uppercase align-middle border border-2 border-dark">
                    <span className="ps-1 fw-bold">Id no: </span>
                    <span className="ps-1 fw-bold">
                      {state?.user?.registration_no?.split(" ")[1] || "---"}
                    </span>
                  </td>
                  <td className="text-uppercase align-middle border border-2 border-dark">
                    <span className="ps-1 fw-bold">Reg no: </span>
                    <span className="ps-1 fw-bold">
                      {state?.user?.registration_no || "---"}
                    </span>
                  </td>
                  <td
                    colSpan={2}
                    className="text-uppercase align-middle border border-2 border-dark"
                  >
                    <span className="text-uppercase ps-1 fw-bold">
                      Passport no:{" "}
                    </span>
                    <span className="text-uppercase ps-1 fw-bold">
                      {state?.user?.passport_no || "---"}
                    </span>
                  </td>
                </tr>
                <tr className="align-middle">
                  <td className="text-uppercase ps-1 fw-bold border border-2 border-dark fw-bold">
                    Country
                  </td>
                  <td className="text-uppercase ps-1 fw-bold border border-2 border-dark fw-bold">
                    {state?.country?.name || "---"}
                  </td>
                  <td className="text-uppercase ps-1 fw-bold border border-2 border-dark">
                    Medical date
                  </td>
                  <td className="text-uppercase ps-1 fw-bold border border-2 border-dark">
                    {formattedMedicalDate || "---"}
                  </td>
                </tr>
                <tr className="align-middle">
                  <td className="text-uppercase ps-1 fw-bold border border-2 border-dark">
                    Name
                  </td>
                  <td
                    className="text-uppercase ps-1 fw-bold border border-2 border-dark"
                    colSpan={3}
                  >
                    {state?.user?.f_name || "---"}
                  </td>
                </tr>
                <tr className="align-middle">
                  <td className="text-uppercase ps-1 fw-bold border border-2 border-dark">
                    Father name
                  </td>
                  <td
                    className="text-uppercase ps-1 fw-bold border border-2 border-dark"
                    colSpan={3}
                  >
                    {state?.father_name || "---"}
                  </td>
                </tr>
                <tr className="align-middle">
                  <td className="text-uppercase ps-1 fw-bold border border-2 border-dark">
                    Date of birth
                  </td>
                  <td className="text-uppercase ps-1 fw-bold border border-2 border-dark">
                    {formattedBirthDate || "---"}
                  </td>
                  <td className="text-uppercase ps-1 fw-bold align-middle border border-2 border-dark">
                    Gender
                  </td>
                  <td className="text-uppercase ps-1 fw-bold align-middle border border-2 border-dark">
                    {state?.gender?.name || "---"}
                  </td>
                </tr>
                <tr>
                  <td className="text-uppercase ps-1 fw-bold align-middle border border-2 border-dark">
                    Agency
                  </td>
                  <td
                    className="text-uppercase ps-1 fw-bold align-middle border border-2 border-dark"
                    colSpan={3}
                  >
                    {state?.introducer_user?.f_name || "---"}{" "}
                  </td>
                </tr>
                {state?.company_user && (
                  <tr>
                    <td className="text-uppercase ps-1 fw-bold align-middle border border-2 border-dark">
                      Company
                    </td>
                    <td
                      className="text-uppercase ps-1 fw-bold align-middle border border-2 border-dark"
                      colSpan={3}
                    >
                      {state?.company_user?.f_name || "---"}{" "}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="col-2 p-1 h-100">
            <div className="report-avatar border">
              {state?.user?.finger_print ? (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}/users/${state?.user?.finger_print}`}
                  className="img-fluid border border-2 border-dark"
                  alt=""
                />
              ) : (
                <div className="p-0 border border-3 border-bottom-1 border-dark text-center text-dark d-flex align-items-center justify-content-center report-avatar">
                  No Fingerprint Found
                </div>
              )}
              <p className="p-0 m-0 w-100 border border-2 border-dark text-center fw-bold text-dark">
                Finger Print
              </p>
            </div>
          </div>
        </div>
      </div>
      {(uniqueCollection?.length < 2 &&
        (state?.user?.is_pathology_done ||
          state?.user?.is_physical_done ||
          state?.user?.is_radiology_done)) ||
      (uniqueCollection?.length >= 2 &&
        uniqueCollection?.length < 3 &&
        (state?.user?.is_physical_done ? 1 : 0) +
          (state?.user?.is_pathology_done ? 1 : 0) +
          (state?.user?.is_radiology_done ? 1 : 0) >=
          2) ||
      (uniqueCollection?.length >= 3 &&
        state?.user?.is_pathology_done &&
        state?.user?.is_physical_done &&
        state?.user?.is_radiology_done) ? (
        <>
          <div className="row mt-4">
            <div className="col-6 pe-3">
              <table className="table table-bordered mb-0">
                <thead className="text-white bg-danger">
                  <tr>
                    <th
                      colSpan={2}
                      className="text-uppercase text-center p-1 fw-bold py-2 align-middle"
                      style={{ backgroundColor: "#fd0166", color: "black" }}
                    >
                      PHYSICAL EXAMINATION
                    </th>
                  </tr>
                </thead>
                <div
                  style={{
                    color: "black",
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                  }}
                >
                  {physicalData?.map((item, i) => (
                    <>
                      <div className="text-left border-end border-bottom border-start p-1 fw-bold">
                        {item?.investigation_test?.investigation?.name}
                      </div>
                      <div
                        className={`text-left border-end border-bottom p-1 fw-bold ${
                          item?.test_id === 15
                            ? item?.result === "Normal"
                              ? "text-success"
                              : physicalRiskFactor > 70
                              ? "text-danger"
                              : "text-primary"
                            : "text-dark"
                        }`}
                      >
                        {item?.result}{" "}
                        {item?.result !== null &&
                          item?.result !== undefined &&
                          item?.result.trim() !== "---" && (
                            <>
                              {
                                item?.investigation?.investigation_tests[0]?.uom
                                  ?.symbol
                              }
                            </>
                          )}
                      </div>
                    </>
                  ))}
                </div>
              </table>
              <table className="table mt-4 table-bordered mb-0">
                <thead className="text-white bg-danger">
                  <tr style={{ backgroundColor: "#fd0166", color: "black" }}>
                    <th
                      colSpan={3}
                      className="text-uppercase text-center py-2 fw-bold"
                    >
                      LABORATORY INVESTIGATION
                    </th>
                  </tr>
                </thead>
                <th colSpan={2} className="border text-center fw-bold">
                  TEST
                </th>
                <th className="border text-center fw-bold">RESULT</th>
                <tbody className="fs-6">
                  <tr>
                    <td
                      className="border ps-1 align-middle fw-bold"
                      rowSpan={
                        state?.package?.id === 1
                          ? 11
                          : state?.package?.id === 2
                          ? 12
                          : state?.package?.id === 3
                          ? 8
                          : state?.package?.id === 4
                          ? 14
                          : undefined
                      }
                    >
                      BLOOD
                    </td>
                  </tr>
                  {state?.package?.id === 2 || state?.package?.id === 4 ? (
                    <tr className="">
                      <td className="text-left border ps-1 fw-bold">
                        Hemoglobin
                      </td>
                      <td className="text-left border ps-1 fw-bold">
                        <div
                          className={`text-left fw-bold ${
                            pathologyData?.find((item) => item?.test_id === 17)
                              ?.result
                              ? (() => {
                                  const resultItem = pathologyData?.find(
                                    (item) => item?.test_id === 17
                                  );
                                  const resultValue = parseFloat(
                                    resultItem?.result
                                  );

                                  if (resultValue > 16 || resultValue < 11.8) {
                                    return "text-primary";
                                  } else {
                                    return "text-dark";
                                  }
                                })()
                              : "text-dark"
                          }`}
                        >
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 17
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            if (result) {
                              const resultValue = parseFloat(result);
                              const textColor =
                                resultValue > 16 || resultValue < 11.8
                                  ? "text-primary"
                                  : "text-dark";

                              return (
                                <>
                                  <span className={`${textColor} fw-bold`}>
                                    {result} {result !== "---" && uomSymbol}{" "}
                                  </span>{" "}
                                  {textColor !== "text-dark" &&
                                    reportNormalValue && (
                                      <>
                                        <span className="text-dark fw-bold">
                                          {" "}
                                          {reportNormalValue}
                                        </span>{" "}
                                      </>
                                    )}
                                </>
                              );
                            }
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}

                  {state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left col-sm-3 border ps-1 fw-bold">
                        S.Creatinine
                      </td>
                      <td className="text-left col-sm-7 border ps-1 fw-bold">
                        <div
                          className={`text-left fw-bold ${(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 19
                            );
                            const result = resultItem?.result;

                            if (result) {
                              const resultValue = parseFloat(result);

                              if (resultValue > 3) {
                                return "text-danger";
                              } else if (
                                resultValue > 1.3 &&
                                resultValue <= 2
                              ) {
                                return "text-primary";
                              } else if (resultValue >= 2 && resultValue < 3) {
                                return "text-primary";
                              } else {
                                return "text-dark";
                              }
                            } else {
                              return "text-dark";
                            }
                          })()}`}
                        >
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 19
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            if (result) {
                              const resultValue = parseFloat(result);
                              let textColor;

                              if (resultValue > 3) {
                                textColor = "text-danger";
                              } else if (
                                resultValue > 1.3 &&
                                resultValue <= 2
                              ) {
                                textColor = "text-primary";
                              } else if (resultValue > 2 && resultValue < 3) {
                                textColor = "text-primary";
                              } else {
                                textColor = "text-dark";
                              }

                              return (
                                <>
                                  <span className={`${textColor} fw-bold`}>
                                    {result} {result !== "---" && uomSymbol}
                                  </span>{" "}
                                  {["text-primary", "text-danger"].includes(
                                    textColor
                                  ) && (
                                    <>
                                      {reportNormalValue && (
                                        <span className="text-dark fw-bold">
                                          {reportNormalValue}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </>
                              );
                            } else {
                              return result;
                            }
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}

                  {state?.package?.id === 1 ||
                  state?.package?.id === 3 ||
                  state?.package?.id === 2 ||
                  state?.package?.id === 4 ? (
                    <tr className="">
                      <td className="text-left border col-sm-3 ps-1 fw-bold">
                        HBsAg
                      </td>
                      <td className="text-left col-sm-7 border ps-1 fw-bold">
                        <div className={`text-left fw-bold`}>
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 27
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            if (result) {
                              return (
                                <>
                                  {result && (
                                    <>
                                      <span
                                        className={
                                          result === "W. Positive"
                                            ? "text-primary fw-bold"
                                            : result === "Positive"
                                            ? "text-danger fw-bold"
                                            : "text-dark fw-bold"
                                        }
                                      >
                                        {result}
                                      </span>{" "}
                                      {result !== "---" && uomSymbol && (
                                        <>
                                          <span
                                            className={
                                              result === "W. Positive"
                                                ? "text-primary fw-bold"
                                                : result === "Positive"
                                                ? "text-danger fw-bold"
                                                : "text-dark fw-bold"
                                            }
                                          >
                                            {uomSymbol}
                                          </span>{" "}
                                          {[
                                            "text-primary",
                                            "text-danger",
                                          ].includes(
                                            result === "W. Positive"
                                              ? "text-primary fw-bold"
                                              : "text-danger fw-bold"
                                          ) && (
                                            <span className="text-dark fw-bold">
                                              {reportNormalValue}
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              );
                            }
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {state?.package?.id === 1 ||
                  state?.package?.id === 2 ||
                  state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left border col-sm-3 ps-1 fw-bold">
                        HIV 1 - 2 Test
                      </td>
                      <td className="text-left col-sm-7 border ps-1 fw-bold">
                        <div className={`text-left fw-bold`}>
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 31
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            let textColor;
                            if (result === "W. Positive") {
                              textColor = "text-primary";
                            } else if (
                              result === "Negative" ||
                              result === "---"
                            ) {
                              textColor = "text-dark";
                            } else {
                              textColor = "text-danger";
                            }

                            return (
                              <>
                                <span className={`${textColor} fw-bold`}>
                                  {result} {result !== "---" && uomSymbol}
                                </span>{" "}
                                {["text-primary", "text-danger"].includes(
                                  textColor
                                ) && (
                                  <>
                                    <span className="text-dark fw-bold">
                                      {reportNormalValue}
                                    </span>{" "}
                                  </>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {state?.package?.id === 1 ||
                  state?.package?.id === 2 ||
                  state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left border col-sm-3 ps-1 fw-bold">
                        Anti-HCV
                      </td>
                      <td className="text-left col-sm-7 border ps-1 fw-bold">
                        <div className={`text-left fw-bold`}>
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 30
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            let textColor;
                            if (result === "W. Positive") {
                              textColor = "text-primary";
                            } else if (
                              result === "Negative" ||
                              result === "---"
                            ) {
                              textColor = "text-dark";
                            } else {
                              textColor = "text-danger";
                            }

                            return (
                              <>
                                <span className={`${textColor} fw-bold`}>
                                  {result} {result !== "---" && uomSymbol}
                                </span>{" "}
                                {["text-primary", "text-danger"].includes(
                                  textColor
                                ) && (
                                  <>
                                    <span className="text-dark">
                                      {reportNormalValue}
                                    </span>{" "}
                                  </>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {state?.package?.id === 1 ||
                  state?.package?.id === 3 ||
                  state?.package?.id === 2 ||
                  state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left col-sm-3 border ps-1 fw-bold">
                        VDRL
                      </td>
                      <td className="text-left col-sm-7 border ps-1 fw-bold">
                        <div className={`text-left fw-bold`}>
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 28
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            const textColor = [
                              "W. Reactive",
                              "Reactive",
                            ].includes(result)
                              ? "text-primary"
                              : result === "Non Reactive" || "---"
                              ? "text-dark"
                              : "text-danger";

                            return (
                              <>
                                <span className={`${textColor} fw-bold`}>
                                  {result} {result !== "---" && uomSymbol}
                                </span>{" "}
                                {["text-primary", "text-danger"].includes(
                                  textColor
                                ) && (
                                  <>
                                    <span className="text-dark">
                                      {reportNormalValue}
                                    </span>{" "}
                                  </>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {state?.package?.id === 1 ||
                  state?.package?.id === 3 ||
                  state?.package?.id === 2 ||
                  state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left border col-sm-3 ps-1 fw-bold">
                        TPHA
                      </td>
                      <td className="text-left border col-sm-7 ps-1 fw-bold">
                        <div className={`text-left fw-bold`}>
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 29
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            let textColor;
                            if (result === "W. Positive") {
                              textColor = "text-primary";
                            } else if (
                              result === "Negative" ||
                              result === "---"
                            ) {
                              textColor = "text-dark";
                            } else {
                              textColor = "text-danger";
                            }

                            return (
                              <>
                                <span className={`${textColor} fw-bold`}>
                                  {result} {result !== "---" && uomSymbol}
                                </span>{" "}
                                {["text-primary", "text-danger"].includes(
                                  textColor
                                ) && (
                                  <>
                                    <span className="text-dark fw-bold">
                                      {reportNormalValue}
                                    </span>{" "}
                                  </>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {state?.package?.id === 1 ||
                  state?.package?.id === 2 ||
                  state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left col-sm-3 border ps-1 fw-bold">
                        Blood Group Rh
                      </td>
                      <td className="text-left col-sm-7 border">
                        <div className="text-left fw-bold ps-1 text-dark fw-bold">
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 21
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            // let textColor;
                            // if (result === "NIL") {
                            //   textColor = "text-primary";
                            // } else {
                            //   textColor = "text-dark";
                            // }

                            return (
                              <>
                                <span className="fw-bold">
                                  {result} {result !== "" && uomSymbol}
                                </span>{" "}
                              </>
                            );
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}

                  {state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left border ps-1 fw-bold">
                        Malarial Parasite
                      </td>
                      <td className="text-left border ps-1 fw-bold">
                        <div
                          className={`text-left fw-bold ${
                            pathologyData?.find((item) => item?.test_id === 25)
                              ?.result === "Found"
                              ? "text-primary"
                              : "text-dark"
                          }`}
                        >
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 25
                            );
                            const result = resultItem?.result;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            if (result) {
                              return (
                                <>
                                  <span
                                    className={
                                      result === "Found"
                                        ? "text-primary fw-bold"
                                        : "text-dark fw-bold"
                                    }
                                  >
                                    {result}{" "}
                                    <span
                                      className={
                                        result === "Found"
                                          ? "text-primary fw-bold"
                                          : "text-dark fw-bold"
                                      }
                                    >
                                      {result !== "---" &&
                                        resultItem?.investigation_test?.uom
                                          ?.symbol}
                                    </span>{" "}
                                  </span>{" "}
                                  {result === "Found" && reportNormalValue && (
                                    <>
                                      <span className="text-dark fw-bold">
                                        {reportNormalValue}{" "}
                                      </span>{" "}
                                    </>
                                  )}
                                </>
                              );
                            }
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}

                  {state?.package?.id === 1 ||
                  state?.package?.id === 3 ||
                  state?.package?.id === 2 ||
                  state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left col-sm-3 border ps-1 fw-bold">
                        S.Bilirubin
                      </td>
                      <td className="text-left col-sm-7 border ps-1 fw-bold">
                        <div
                          className={`text-left fw-bold ${
                            pathologyData?.find((item) => item?.test_id === 22)
                              ?.result &&
                            parseFloat(
                              pathologyData?.find(
                                (item) => item?.test_id === 22
                              )?.result
                            ) > 0.99
                              ? "text-primary fw-bold"
                              : parseFloat(
                                  pathologyData?.find(
                                    (item) => item?.test_id === 22
                                  )?.result
                                ) > 3
                              ? "text-danger fw-bold"
                              : "text-dark fw-bold"
                          }`}
                        >
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 22
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            if (result) {
                              const resultValue = parseFloat(result);
                              const textColor =
                                resultValue > 0.99
                                  ? "text-primary fw-bold"
                                  : resultValue > 3
                                  ? "text-danger fw-bold"
                                  : "text-dark fw-bold";

                              return (
                                <>
                                  <span className={textColor}>
                                    {result} {result !== "---" && uomSymbol}{" "}
                                  </span>{" "}
                                  {["text-primary", "text-danger"].includes(
                                    textColor
                                  ) && (
                                    <>
                                      {reportNormalValue && (
                                        <span className="text-dark fw-bold">
                                          {reportNormalValue}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </>
                              );
                            } else {
                              return result;
                            }
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {state?.package?.id === 1 ||
                  state?.package?.id === 3 ||
                  state?.package?.id === 2 ||
                  state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left col-sm-3 border ps-1 fw-bold">
                        SGPT
                      </td>
                      <td className="text-left col-sm-7 border ps-1 fw-bold">
                        <div
                          className={`text-left fw-bold ${
                            pathologyData?.find((item) => item?.test_id === 23)
                              ?.result &&
                            parseFloat(
                              pathologyData?.find(
                                (item) => item?.test_id === 23
                              )?.result
                            ) > 41
                              ? "text-primary"
                              : "text-dark"
                          }`}
                        >
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 23
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            if (result) {
                              const resultValue = parseFloat(result);
                              const textColor =
                                resultValue > 41
                                  ? "text-primary fw-bold"
                                  : "text-dark fw-bold";

                              return (
                                <>
                                  <span className={textColor}>
                                    {result} {result !== "---" && uomSymbol}{" "}
                                  </span>{" "}
                                  {["text-primary", "text-danger"].includes(
                                    textColor
                                  ) && (
                                    <>
                                      <span className="text-dark fw-bold">
                                        {" "}
                                        {reportNormalValue}
                                      </span>{" "}
                                    </>
                                  )}
                                </>
                              );
                            } else {
                              return result;
                            }
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {state?.package?.id === 1 ||
                  state?.package?.id === 3 ||
                  state?.package?.id === 2 ||
                  state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left col-sm-3 border ps-1 fw-bold">
                        SGOT
                      </td>
                      <td className="text-left col-sm-7 border ps-1 fw-bold">
                        <div
                          className={`text-left fw-bold ${
                            pathologyData?.find((item) => item?.test_id === 24)
                              ?.result &&
                            parseFloat(
                              pathologyData?.find(
                                (item) => item?.test_id === 24
                              )?.result
                            ) > 38
                              ? "text-primary fw-bold"
                              : "text-dark fw-bold"
                          }`}
                        >
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 24
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            if (result) {
                              const resultValue = parseFloat(result);
                              const textColor =
                                resultValue > 38
                                  ? "text-primary fw-bold"
                                  : "text-dark fw-bold";

                              return (
                                <>
                                  <span className={textColor}>
                                    {result} {result !== "---" && uomSymbol}{" "}
                                  </span>{" "}
                                  {["text-primary", "text-danger"].includes(
                                    textColor
                                  ) && (
                                    <>
                                      <span className="text-dark fw-bold">
                                        {reportNormalValue}
                                      </span>{" "}
                                    </>
                                  )}
                                </>
                              );
                            } else {
                              return result;
                            }
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {state?.package?.id === 1 ||
                  state?.package?.id === 3 ||
                  state?.package?.id === 2 ||
                  state?.package?.id === 4 ? (
                    <tr>
                      <td className="text-left col-sm-3 border ps-1 fw-bold">
                        R.B.S.
                      </td>
                      <td className="text-left col-sm-7 border ps-1 fw-bold">
                        <div
                          className={`text-left fw-bold ${
                            pathologyData?.find((item) => item?.test_id === 18)
                              ?.result
                              ? (() => {
                                  const resultItem = pathologyData?.find(
                                    (item) => item?.test_id === 18
                                  );
                                  const resultValue = parseFloat(
                                    resultItem?.result
                                  );

                                  if (resultValue > 7.5) {
                                    return "text-primary fw-bold";
                                  } else if (resultValue > 25) {
                                    return "text-danger fw-bold";
                                  } else {
                                    return "text-dark fw-bold";
                                  }
                                })()
                              : "text-dark"
                          }`}
                        >
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 18
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            if (result) {
                              const resultValue = parseFloat(result);
                              const textColor =
                                resultValue > 7
                                  ? "text-primary fw-bold"
                                  : resultValue > 25
                                  ? "text-danger fw-bold"
                                  : "text-dark fw-bold";

                              return (
                                <span className={textColor}>
                                  {result} {result !== "---" && uomSymbol}{" "}
                                  {["text-primary", "text-danger"].includes(
                                    textColor
                                  ) && (
                                    <>
                                      {reportNormalValue && (
                                        <span className="text-dark fw-bold">
                                          {reportNormalValue}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </span>
                              );
                            }
                          })()}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}

                  <tr>
                    <td className="border ps-1 fw-bold" rowSpan={rowSpanValue}>
                      URINE
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left col-sm-3 border ps-1 fw-bold">
                      C.U. Sugar
                    </td>
                    <td className="text-left col-sm-7 border">
                      <div className="text-left fw-bold ps-1 text-dark fw-bold">
                        {(() => {
                          const resultItem = pathologyData?.find(
                            (item) => item?.test_id === 26
                          );
                          const result = resultItem?.result;
                          const uomSymbol =
                            resultItem?.investigation_test?.uom?.symbol;
                          const reportNormalValue =
                            resultItem?.investigation_test?.report_normal_value;

                          // let textColor;
                          // if (result === "NIL") {
                          //   textColor = "text-primary";
                          // } else {
                          //   textColor = "text-dark";
                          // }

                          return (
                            <>
                              <span className="fw-bold">
                                {result} {result !== "" && uomSymbol}
                              </span>{" "}
                            </>
                          );
                        })()}
                      </div>
                    </td>
                  </tr>
                  {state?.gender?.id === 2 && pregnancyField === 1 && (
                    <tr>
                      <td className="text-left col-sm-3 border ps-1 fw-bold">
                        Pregnancy
                      </td>
                      <td className="text-left col-sm-7 border fw-bold">
                        <div
                          className={`text-left fw-bold ps-1 ${
                            ["W. Positive", "Positive"].includes(
                              pathologyData?.find(
                                (item) => item?.test_id === 37
                              )?.result
                            )
                              ? "text-primary fw-bold"
                              : "text-dark fw-bold"
                          }`}
                        >
                          {(() => {
                            const resultItem = pathologyData?.find(
                              (item) => item?.test_id === 37
                            );
                            const result = resultItem?.result;
                            const uomSymbol =
                              resultItem?.investigation_test?.uom?.symbol;
                            const reportNormalValue =
                              resultItem?.investigation_test
                                ?.report_normal_value;

                            if (result) {
                              const textColor =
                                result === "Positive" ||
                                result === "W. Positive"
                                  ? "text-primary fw-bold"
                                  : "text-dark fw-bold";

                              return (
                                <span className={`${textColor} fw-bold`}>
                                  {result} {uomSymbol}
                                  {["text-primary", "text-danger"].includes(
                                    textColor
                                  ) && (
                                    <>
                                      {["text-primary", "text-danger"].includes(
                                        textColor
                                      ) && (
                                        <span className="text-dark">
                                          {reportNormalValue}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </span>
                              );
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {state?.user?.status !== 2 && (
                <div className="col-12 mt-4">
                  <table className="table table-bordered mb-0 mt-2">
                    <thead className="text-white bg-danger">
                      <tr
                        style={{ backgroundColor: "#fd0166", color: "black" }}
                      >
                        <th
                          colSpan={2}
                          className="text-uppercase text-center py-2 fw-bold"
                        >
                          RISK FACTOR
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-left p-1 mx-auto w-25 fw-bold">
                          Risk Factor
                        </td>
                        <td>
                          <span
                            className="text-left p-0 m-0 ps-1 fw-bold"
                            style={{ wordBreak: "break-word" }}
                          >
                            {physicalCommentRisk && (
                              <>
                                Physical:{" "}
                                <span
                                  style={{
                                    color:
                                      physicalCommentRisk <= 70
                                        ? "#0000FF"
                                        : physicalCommentRisk > 70
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {physicalCommentRisk}% Risk,
                                </span>
                              </>
                            )}
                            {pathologyCommentRisk ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ` Pathology: ${pathologyCommentRisk}`,
                                }}
                              />
                            ) : (
                              ""
                            )}
                            {radiologyRiskFactor && (
                              <>
                                {" "}
                                X-Ray:{" "}
                                <span
                                  style={{
                                    color:
                                      radiologyRiskFactor <= 70
                                        ? "#0000FF"
                                        : radiologyRiskFactor > 70
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {radiologyRiskFactor}% Risk
                                </span>
                              </>
                            )}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="col-6 ps-3">
              <table className="table table-bordered mb-0 fw-bold">
                <thead className="text-white bg-danger">
                  <tr>
                    <th
                      colSpan={2}
                      className="text-uppercase text-center py-2 fw-bold"
                      style={{ backgroundColor: "#fd0166", color: "black" }}
                    >
                      X-RAY (CHEST P/A) VIEW
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {radiologyData?.map((item, i) => (
                    <tr key={i}>
                      <td className="text-left p-1 w-25 fw-bold">
                        {item?.investigation_test.name === "Findings"
                          ? "Comment"
                          : item?.investigation_test.name}
                      </td>
                      <td
                        className={`text-left p-1 fw-bold ${
                          item?.test_id === 35 &&
                          item?.investigation_test.name === "Findings"
                            ? item?.result === "Normal CXR"
                              ? "text-success"
                              : item?.riskFactor > 70
                              ? "text-danger"
                              : "text-primary"
                            : "text-dark"
                        }`}
                      >
                        {item?.result}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <table className="table mt-4 table-bordered border mb-0">
                <thead className="text-white bg-danger">
                  <tr>
                    <th
                      colSpan={2}
                      className="text-uppercase text-center py-2"
                      style={{ backgroundColor: "#fd0166", color: "black" }}
                    >
                      DIGITAL CXR
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {radiologyData?.length > 0 ? (
                        <img
                          src={`${process.env.REACT_APP_UPLOAD_URL}/${radiologyData[0]?.user_file}`}
                          alt="Xray film"
                          className="w-100"
                          style={{ height: "330px", objectFit: "fill" }}
                        />
                      ) : (
                        <div
                          className="text-center d-flex align-items-center justify-content-center"
                          style={{ height: "330px" }}
                        >
                          No X-Ray film found
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row" style={{ marginTop: "6rem" }}>
            <div className="row w-100">
              <div className="text-start">
                <p className="text-uppercase m-0 text-dark">
                  Mentioned above is the medical report for{" "}
                  {state?.user?.f_name}, who is
                  <span
                    className="fw-bold text-uppercase fs-5"
                    style={{
                      color: `${
                        state?.user?.status === 1
                          ? "black"
                          : state?.user?.status === 2
                          ? "#5cb85c"
                          : state?.user?.status === 3
                          ? "red"
                          : state?.user?.status === 4 && "#0000FF"
                      }`,
                    }}
                  >
                    {state?.user?.status === 1 && ` PROCESSING`}
                    {state?.user?.status === 2 && ` FIT`}
                    {state?.user?.status === 3 && ` UNFIT`}
                    {state?.user?.status === 4 && ` HELD UP`}
                  </span>{" "}
                  for the above mentioned job according to the medical criteria.{" "}
                </p>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </section>
  );
};

export default VerificationReportById;
